import { cn } from '@eliadmin/core/src/utils/style-utils';

export const Heading = ({
  title,
  className,
  as: Tag = 'h2',
}: {
  title: string;
  className?: { container?: string; line?: string; title?: string };
  as?: 'h1' | 'h2';
}) => {
  return (
    <div className={cn('flex w-fit flex-col items-end justify-end gap-0', className?.container)}>
      <div className={cn('h-[3px] w-16 bg-primary', className?.line)} />
      <Tag data-ea-visual-tag={Tag === 'h1' ? 'h2' : undefined} className={cn('text-3xl font-semibold text-foreground', className?.title)}>{title}</Tag>
    </div>
  );
};
